import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogAuthor/BlogAuthor.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/BlogContent.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppCostCalculator"] */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/AppCostCalculator/AppCostCalculator.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogCallout/BlogCallout.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogCtaBanner/BlogCtaBanner.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogTable/BlogTable.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogStages/BlogStages.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogCaseCard/BlogCaseCard.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogChips/BlogChips.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogQuote/BlogQuote.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogContent/components/BlogCode/BlogCode.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlogFaq"] */ "/home/runner/work/udata-site/udata-site/components/BlogPage/BlogFaq/BlogFaq.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/ServicesPage/ServiceLandingPage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceStructuredData"] */ "/home/runner/work/udata-site/udata-site/components/ServicesPage/ServiceStructuredData.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/UI/Breadcrumbs/Breadcrumbs.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/UI/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/components/UI/RelatedPosts/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/udata-site/udata-site/node_modules/next/dist/client/image-component.js");
